var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.link,attrs:{"href":_vm.href,"target":_vm.target,"rel":_vm.rel,"download":_vm.download ? _vm.downloadName : false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }